export default "__VITE_ASSET__D$cuhsCR__"